import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid"
import moment from "moment";
import _ from "lodash";
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';

import { Button, CalendarField, TextInputField } from "../../../helpers";
import Tooltip from "../../../helpers/Tooltip";

import PoRescheduleReasonModel from "./PoRescheduleReasonModal"

import { insertPOSchedule } from "../../../services/api/poSchedule";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchPoRescheduleReasonList } from "../../../services/redux/reducers/commonThunk";

import RecurringPoModal from "./RecurringPoModal";
import SubmitPOQuantity from "./SubmitPOQuantity";
import SmartScheduler from "./SmartScheduler"

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OverlayPanel } from 'primereact/overlaypanel'

import { checkPermissions, getBranchComparision, getDateString, getFullName, getProductName, getProductSpecification, getUOMStr, sortArrayOfObjectsInAscendingDateOrder } from "../../../utils";

import "../index.css"


const Scheduling = (props) => {
    let { getBuyerPO, materialData, showSubmitPO, handleUpdatedPOPunch, poPunchItems, poPunchCreatedUsers, setBuyerPO, poPunch, setIsLoading, buyerPOItems, buyerPO, poSchedule, poScheduleItems, setBuyerPOItems, scheduleCreatedUsers, dispatchNoteItems } = props
    const tableRef = useRef(null);
    const overlayPanelRef = useRef(null)
    const [isEditable, setIsEditable] = useState(false)

    const [initialPOSchedule, setInitialPOSchedule] = useState(poSchedule)
    const [initialPOScheduleItems, setInitialPOScheduleItems] = useState(poScheduleItems)
    const [datewisePOSchedule, setDatewisePOSchedule] = useState([])
    const [datewisePOScheduleItems, setDatewisePOScheduleItems] = useState([])
    const [isSelectReasonModelVisible, setIsSelectReasonModelVisible] = useState(false)
    const [isReccuringPoModalVisible, setIsReccuringPoModalVisible] = useState(false)
    const [selectedColumnId, setSelectedColumnId] = useState(null)
    const [selectedScheduledDate, setSelectedScheduledDate] = useState(null)
    const [disablePunchButton, setDisablePunchButton] = useState(false)
    const [updatedBuyerPOItems, setUpdatedBuyerPOItems] = useState([])
    const [isSmartSchedulerVisible, setIsSmartSchedulerVisible] = useState(false)

    const usersData = useSelector(state => state.userDetails)
    const brandData = useSelector((state) => state.common.materialBrands)
    let poRescheduleReasons = useSelector(state => state.common.poRescheduleReasonList)


    useEffect(() => {
        if (buyerPOItems.length > 0) {
            const dummyBuyerPOItem = {
                bPOGSTRate: null,
                bPOHSNCode: null,
                bPOItemAmountBeforeTax: null,
                bPOItemAmountWithTax: null,
                bPOListPrice: null,
                bPOQty: null,
                bPOUnitPrice: null,
                buyerPOId: null,
                buyerPOItemId: null,
                buyerQuoteItemId: null,
                buyerRateContractId: null,
                buyerReqId: null,
                buyerReqItemId: null,
                columnViseValues: {},
                companyERPCode: null,
                createdAt: null,
                createdBy: null,
                currency: null,
                currencyRate: null,
                docNo: null,
                fileNo: null,
                leadTime: null,
                materialId: null,
                shipsFromAddrId: null,
                statusId: null,
                updatedAt: null,
                updatedBy: null
            }

            setUpdatedBuyerPOItems([...buyerPOItems, dummyBuyerPOItem])
        }
    }, [buyerPOItems])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchPoRescheduleReasonList(true))
    }, [])

    useEffect(() => {
        const updatedPOSchedule = initialPOSchedule.map(schedule => {
            const relatedPoScheduleItems = initialPOScheduleItems.filter(item => item.columnId === schedule.columnId && item.scheduledQty > 0)
    
            const isScheduleDispatched = relatedPoScheduleItems.every(scheduleItem => {
                const relatedPunchItem = poPunchItems.find(punchItem => punchItem.poScheduleItemId === scheduleItem.poScheduleItemId)

                if (!relatedPunchItem) {
                    return false
                }

                const totalDispatchedQty = dispatchNoteItems
                    .filter(dispatchItem => dispatchItem.poScheduleItemId === scheduleItem.poScheduleItemId)
                    .reduce((sum, dispatchItem) => sum + dispatchItem.qty, 0)
    
                return totalDispatchedQty === relatedPunchItem.punchQty
            })
    
            const isSchedulePunched = relatedPoScheduleItems.some(scheduleItem =>
                poPunchItems.some(punchItem => punchItem.poScheduleItemId === scheduleItem.poScheduleItemId)
            )

            const relatedPunchedItem = poPunchItems.find(each => each.poScheduleItemId === relatedPoScheduleItems[0].poScheduleItemId)
            const relatedDispatchNoteItem = dispatchNoteItems.find(each => each?.poScheduleItemId === relatedPoScheduleItems[0].poScheduleItemId)
            let punchOnDate = null
            let dispatchedOnDate = null
            if (relatedPunchedItem) {
                punchOnDate = moment(relatedPunchedItem?.createdAt).format("YYYY-MM-DD")
            }

            if (relatedDispatchNoteItem) {
                dispatchedOnDate = moment(relatedDispatchNoteItem?.createdAt).format("YYYY-MM-DD")
            }

            return {
                ...schedule,
                isScheduleDispatched,
                isSchedulePunched,
                punchedOn: punchOnDate,
                dispatchedOn: dispatchedOnDate
            }
        })
        setDatewisePOSchedule(updatedPOSchedule)
        setInitialPOSchedule(updatedPOSchedule)
    }, [initialPOScheduleItems, poPunchItems, dispatchNoteItems])

    const areAllScheduleItemsPunched = (schedule, scheduleItems) => {
        const relatedPoScheduleItems = scheduleItems.filter(item => item.columnId === schedule.columnId && item.scheduledQty > 0)
        const punchedScheduleItemIds = poPunchItems.map(each => each.poScheduleItemId)
        return relatedPoScheduleItems.every(scheduleItem =>
            punchedScheduleItemIds.includes(scheduleItem.poScheduleItemId)
        )
    }

    const getPunchingIndex = (schedules, scheduleItems) => {
        return schedules.findIndex(schedule => !areAllScheduleItemsPunched(schedule, scheduleItems))
    }

    const punchingIndex = getPunchingIndex(initialPOSchedule, initialPOScheduleItems)

    useEffect(() => {
        let dateWiseSchedules = {}

        let relatedPOScheduleItems = poScheduleItems?.filter(eachPOScheduleItem => eachPOScheduleItem?.statusId === 1)
        relatedPOScheduleItems?.map(eachPOScheduleItem => {
            if (Object.keys(dateWiseSchedules).includes(eachPOScheduleItem?.scheduledDate)) {
                dateWiseSchedules[eachPOScheduleItem.scheduledDate].push(eachPOScheduleItem)
            } else {
                dateWiseSchedules[eachPOScheduleItem.scheduledDate] = [eachPOScheduleItem]
            }
        })

        let newPOSchedules = []
        let newPOScheduleItems = []
        Object.keys(dateWiseSchedules)?.map(eachSchedule => {
            let newSchedule = { scheduledDate: eachSchedule, columnId: uuid(), isNew: false }
            /*let newScheduleItems = dateWiseSchedules[eachSchedule]?.map(eachScheduleItem => {
                const relatedBuyerPOItem = buyerPOItems?.find(eachBuyerPOItem => eachBuyerPOItem?.buyerPOItemId === eachScheduleItem?.buyerPOItemId)
                console.log("eachScheduleItem", eachScheduleItem)
                return { ...eachScheduleItem, columnId: newSchedule?.columnId, columnItemId: uuid(), isNew: false, ...relatedBuyerPOItem }
            })*/
            let newScheduleItems = buyerPOItems.map(eachBuyerPOItem => {
                const relatedPOScheduleDateItem = dateWiseSchedules[eachSchedule].find(eachScheduleItem => eachScheduleItem.buyerPOItemId === eachBuyerPOItem.buyerPOItemId)
                if(relatedPOScheduleDateItem) {
                    return { ...relatedPOScheduleDateItem, ...eachBuyerPOItem, isNew: false, columnItemId: uuid(), columnId: newSchedule.columnId}
                } else {
                    const newPOScheduleDateItem = {
                        "buyerReqId": eachBuyerPOItem.buyerReqId,
                        "buyerReqItemId": eachBuyerPOItem.buyerReqItemId,
                        "buyerPOId": eachBuyerPOItem.buyerPOId,
                        "buyerPOItemId": eachBuyerPOItem.buyerPOItemId,
                        "fileNo": eachBuyerPOItem.fileNo,
                        "docNo": eachBuyerPOItem.docNo,
                        "scheduledQty": 0,
                        "scheduledDate": newSchedule.scheduledDate,
                        "statusId": 1,
                        "createdAt": new Date(),
                        "updatedAt": new Date()
                    }
                    return { ...newPOScheduleDateItem, ...eachBuyerPOItem, isNew: false, columnItemId: uuid(), columnId: newSchedule.columnId}
                }
            })
            newPOSchedules.push(newSchedule)
            newPOScheduleItems.push(...newScheduleItems)
        })

        let sortedPOSchedule = sortArrayOfObjectsInAscendingDateOrder(newPOSchedules, "scheduledDate")
        setInitialPOSchedule(sortedPOSchedule)
        setInitialPOScheduleItems(newPOScheduleItems)
        setDatewisePOSchedule(sortedPOSchedule)
        setDatewisePOScheduleItems(newPOScheduleItems)
    }, [poScheduleItems])

    const handlePunchClick = (columnId, scheduledDate) => {
        setSelectedColumnId(columnId)
        setSelectedScheduledDate(new Date(scheduledDate))
        setIsReccuringPoModalVisible(true)
    }

    useEffect(() => {
        // Automatically scroll to the right when a new column is added
        if (datewisePOSchedule.length > 2 && tableRef.current?.container) {
            const tableBody = tableRef.current.container.querySelector('.p-datatable-scrollable-body');
            if (tableBody) {
                tableBody.scrollLeft = tableBody.scrollWidth;
            }
        }
    }, [datewisePOSchedule])

    const handleInputChange = (e, columnItemId, buyerPOItemId) => {
        let totalScheduledQty = 0
        buyerPOItems.map(eachBuyerPOItem => {
            datewisePOScheduleItems?.map(eachPOScheduleItem => {
                if (eachBuyerPOItem.buyerPOItemId === buyerPOItemId){
                    if (eachPOScheduleItem.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId && eachPOScheduleItem?.columnItemId !== columnItemId) {
                        totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
                    }
                }
            })
        })

        const updatedNewPOScheduleItems = datewisePOScheduleItems?.map(eachPOScheduleItem => {
            if (eachPOScheduleItem?.columnItemId === columnItemId){
                if (e.target.value.length > 1 && e.target.value[0] === "0"){
                    e.target.value = e.target.value.substring(1)
                }
                let availableQty = eachPOScheduleItem?.bPOQty - totalScheduledQty

                if (e.target.value === ""){
                    return { ...eachPOScheduleItem, [e.target.name]: 0 }
                } else {
                    if (e.target.value <= availableQty) {
                        return { ...eachPOScheduleItem, [e.target.name]: e.target.value }
                    } else {
                        dispatch(raiseToast({ severity: 'error', detail: `Available Qty : ${parseFloat(availableQty)} Only`, life: 3000 }))
                        return { ...eachPOScheduleItem, [e.target.name]: availableQty }
                    }
                }
            }
            return eachPOScheduleItem
        })
        setDatewisePOScheduleItems(updatedNewPOScheduleItems)
    }

    const handleEditClick = () => {
        setDisablePunchButton(true)
        if (!buyerPO.isRecurringPO && poSchedule?.length >= 2) {
            const {isPermitted} = checkPermissions({ ...usersData, permissions: [17] }, "testing")
            if (isPermitted) {
                setIsEditable(true)
            } else {
                dispatch(raiseToast({ severity: 'warn', detail: "PO Schedule Can't be Edited as it already has two PO Schedules", life: 3000 }))
            }
        } else {
            setIsEditable(true)
        }
    }
    const handleReScheduleClick = () => {
        setIsSelectReasonModelVisible(true)
    }

    const handleHeaderDateChange = (e, columnId) => {
        const isDateAlreadyPresent = datewisePOSchedule?.some(eachPOSchedule => {
            let relatedScheduledDate = new Date(eachPOSchedule?.scheduledDate)
            if (relatedScheduledDate){
                relatedScheduledDate.setMinutes(0)
                relatedScheduledDate.setSeconds(0)
                relatedScheduledDate.setHours(0)
            }

            let selectedDate = e.target.value
            if (selectedDate){
                selectedDate.setMinutes(0)
                selectedDate.setSeconds(0)
                selectedDate.setHours(0)
            }
            return Date.parse(relatedScheduledDate) === Date.parse(selectedDate)
        })

        if (!isDateAlreadyPresent) {
            const updatedNewPOSchedule = datewisePOSchedule?.map(eachPOSchedule => {
                if (eachPOSchedule?.columnId === columnId) {
                    return { ...eachPOSchedule, scheduledDate: e.target.value }
                }
                else {
                    return eachPOSchedule
                }
            })
            let sortedPOSchedule = sortArrayOfObjectsInAscendingDateOrder(updatedNewPOSchedule, "scheduledDate")
            setDatewisePOSchedule(sortedPOSchedule)
        } else {
            dispatch(raiseToast({ severity: 'warn', detail: "Selected Date is already present.", life: 3000 }))
        }
    }

    const handleScheduledClick = async (buyerPOs, rescheduleDocProof) => {
        const activeRoleId = usersData?.activeRoleId
        const relatedUserCompany = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
        let updatedPOScheduleItems = []
        const punchedScheduleItemIds = []
        const dispatchedScheduleItemIds = []

        let changeFollowUpDate = false
        let warehouseAlert = false
        let updateSellerPOItemDetails = []

        initialPOSchedule.forEach(eachInitialPoSchedule => {
            const relatedDateWiseSchedule = datewisePOSchedule.find(
                each => eachInitialPoSchedule.isSchedulePunched && each.columnId === eachInitialPoSchedule.columnId
            )

            if (relatedDateWiseSchedule) {
                const initialScheduleDate = moment(eachInitialPoSchedule.scheduledDate).format('YYYY-MM-DD')
                const newScheduleDate = moment(relatedDateWiseSchedule.scheduledDate).format('YYYY-MM-DD')

                let followUpDate = new Date()
                const currentHour = followUpDate.getHours()

                if (currentHour > 13) {
                    followUpDate.setDate(followUpDate.getDate() + 1)
                }
                const followUpData = initialScheduleDate > newScheduleDate
                    ? { followUpDate: moment(followUpDate).format('YYYY-MM-DD'), followUpStatusId: 1, expectedClientDeliveryDateStatus: true }
                    : {followUpDate: moment(followUpDate).format('YYYY-MM-DD'), followUpStatusId: 9, expectedClientDeliveryDateStatus: true}

                if (initialScheduleDate !== newScheduleDate) {
                    if (initialScheduleDate > newScheduleDate) changeFollowUpDate = true
                    if (initialScheduleDate < newScheduleDate) warehouseAlert = true

                    datewisePOScheduleItems
                        .filter(item => item.columnId === relatedDateWiseSchedule.columnId)
                        .forEach(item => {
                            const relatedPoPunchItem = poPunchItems.find(each => each.poScheduleItemId === item.poScheduleItemId)
                            if (relatedPoPunchItem) {
                                updateSellerPOItemDetails.push({
                                    [parseInt(relatedPoPunchItem.poPunchItemId)]: {
                                        ...followUpData,
                                        expectedClientDeliveryDate: newScheduleDate
                                    }
                                })
                            }
                        })
                }
            }
        })

        datewisePOScheduleItems?.map(eachPOScheduleItem => {
            const relatedPOSchedule = datewisePOSchedule?.find(eachPOSchedule => eachPOSchedule?.columnId === eachPOScheduleItem?.columnId)
            const relatedPoPunchItem = poPunchItems.find(each => each?.poScheduleItemId === eachPOScheduleItem.poScheduleItemId)
            const relatedDispatchNoteItem = dispatchNoteItems.find(each => each?.poScheduleItemId === eachPOScheduleItem.poScheduleItemId)
            let updatedPOScheduleItem = {
                buyerPOItemId: eachPOScheduleItem?.buyerPOItemId,
                fileNo: eachPOScheduleItem?.fileNo,
                docNo: eachPOScheduleItem?.docNo,
                buyerReqId: eachPOScheduleItem?.buyerReqId,
                buyerPOId: eachPOScheduleItem?.buyerPOId,
                buyerReqItemId: eachPOScheduleItem?.buyerReqItemId,
                scheduledQty: eachPOScheduleItem?.scheduledQty,
                scheduledDate: moment(relatedPOSchedule.scheduledDate).format('YYYY-MM-DD'),
                createdBy: usersData?.userId,
                updatedBy: usersData?.userId,
                leadTime: eachPOScheduleItem?.leadTime,
                pmCompanyId: relatedUserCompany?.pmCompanyId,
                pmBranchId: buyerPOs?.pmBranchId,
                poScheduleItemId: eachPOScheduleItem.poScheduleItemId,
                poPunchItemId: relatedPoPunchItem?.poPunchItemId,
                dispatchNoteItemId: eachPOScheduleItem?.dispatchNoteItemId,
                statusId: 1,
            }
            if (updatedPOScheduleItem?.scheduledQty > 0) {
                updatedPOScheduleItems.push(updatedPOScheduleItem)
            }
            if (relatedPoPunchItem?.poScheduleItemId) {
                punchedScheduleItemIds.push(relatedPoPunchItem.poScheduleItemId)
            }
            if(relatedDispatchNoteItem?.poScheduleItemId){
                dispatchedScheduleItemIds.push(relatedDispatchNoteItem.poScheduleItemId)
            }
        })
        let allProcessed = buyerPOItems?.every(eachBuyerPOItem => {
            const relatedPOScheduleItems = datewisePOScheduleItems?.filter(eachPOScheduleItem => eachPOScheduleItem?.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId)
            let totalScheduledQty = 0
            relatedPOScheduleItems?.map(eachPOScheduleItem => {
                totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
            })
            return totalScheduledQty === eachBuyerPOItem?.bPOQty
        })

        if (allProcessed) {
            let date_missing_flag = false
            datewisePOSchedule.map(eachPOSchedule => {
                if (!eachPOSchedule?.scheduledDate) {
                    date_missing_flag = true
                }
            })
            if (date_missing_flag) {
                return dispatch(raiseToast({ severity: 'error', detail: "Please Select Schedule Date", life: 3000 }))
            }
            let latestPOSchedule = _.maxBy(poSchedule, "poScheduleId")
            let isChangesDoneInPOSchedule = false
            let isChangesDoneInPOScheduleItems = false

            isChangesDoneInPOSchedule = datewisePOSchedule?.some(eachDateWisePOSchedule => {
                let relatedInitialPOSchedule = initialPOSchedule?.find(eachPOSchedule => eachPOSchedule?.columnId === eachDateWisePOSchedule?.columnId)
                if (relatedInitialPOSchedule) {
                    return moment(eachDateWisePOSchedule?.scheduledDate).format("YYYY-MM-DD") !== relatedInitialPOSchedule?.scheduledDate
                } else {
                    return true
                }
            })

            isChangesDoneInPOScheduleItems = datewisePOScheduleItems?.some(eachDateWisePOScheduleItem => {
                let relatedInitialPOScheduleItem = initialPOScheduleItems?.find(eachPOScheduleItem => eachPOScheduleItem?.columnItemId === eachDateWisePOScheduleItem?.columnItemId)
                if (relatedInitialPOScheduleItem) {
                    return parseFloat(eachDateWisePOScheduleItem?.scheduledQty) !== parseFloat(relatedInitialPOScheduleItem?.scheduledQty)
                } else {
                    return true
                }
            })

            if (isChangesDoneInPOSchedule || isChangesDoneInPOScheduleItems) {
                if (updatedPOScheduleItems?.length > 0) {
                    let response
                    let data = {
                        poScheduleId: latestPOSchedule?.poScheduleId,
                        poSchedule: {
                            buyerPOId: buyerPOs?.buyerPOId,
                            buyerReqId: buyerPOs?.buyerReqId,
                            fileNo: buyerPOs?.fileNo,
                            docNo: buyerPOs?.docNo,
                            pmBillAddrId: buyerPOs?.pmBillAddrId,
                            pmCompanyId: relatedUserCompany?.pmCompanyId,
                            pmBranchId: buyerPOs?.pmBranchId,
                            statusId: 1,
                            createdBy: usersData?.userId,
                            updatedBy: usersData?.userId,
                            poRescheduleReasonId: buyerPOs?.poRescheduleReasonId,
                            docProof: rescheduleDocProof
                        },
                        poScheduleItems: updatedPOScheduleItems,
                        prevPOSchedule: poSchedule,
                        buyerPOId: buyerPO?.buyerPOId,
                        punchedScheduleItemIds: punchedScheduleItemIds,
                        dispatchedScheduleItemIds: dispatchedScheduleItemIds,
                        changeFollowUpDate: changeFollowUpDate,
                        updateSellerPOItemDetails: updateSellerPOItemDetails
                    }
                    let confirmMsg;

                    if (changeFollowUpDate && warehouseAlert) {
                        confirmMsg = "This will trigger an immediate follow-up with the vendor to try and expedite the dispatch if the seller PO was already created. This will also alert the Warehouse team, and the seller will be intimated of the delay if already assigned.\nAre you sure you want to continue?"
                    } else if (changeFollowUpDate) {
                        confirmMsg = "This will trigger an immediate follow-up with the vendor to try and expedite the dispatch if the seller PO was already created.\nAre you sure you want to continue?"
                    } else if (warehouseAlert) {
                        confirmMsg = "This will alert the Warehouse team and the seller will be intimated of the delay if already assigned. Are you sure you want to continue?"
                    } else {
                        confirmMsg = "Do you want to schedule?"
                    }

                    if (window.confirm(confirmMsg)) {
                        setIsLoading(true)
                        response = await insertPOSchedule(data)
                        if (response?.failure) {
                            dispatch(raiseToast({ severity: 'error', summary: 'PO Schedule', detail: response?.data?.error, life: 3000 }))
                        } else {
                            dispatch(raiseToast({ severity: 'success', detail: "PO Schedule is Done", life: 3000 }))
                            const updatedBuyerPOItemsData = buyerPOItems.map(eachBuyerPOItem => {
                                return { ...eachBuyerPOItem, scheduledDate: "" }
                            })
                            setIsEditable(false)
                            setDisablePunchButton(false)
                            setBuyerPOItems(updatedBuyerPOItemsData)
                            getBuyerPO()
                        }
                    }
                }
            } else {
                dispatch(raiseToast({ severity: 'error', detail: "Please Change the Date/Qty to Re-Schedule", life: 3000 }))
            }
        } else {
            dispatch(raiseToast({ severity: 'error', detail: "Please Complete Scheduling for all items and total qty", life: 3000 }))
        }
        setIsLoading(false)
    }

    const handleAddClick = () => {
        if(datewisePOSchedule.length === 0){
            setIsSmartSchedulerVisible(true)
        }else{
            handleCustomScheduler()
        }
    }

    const handleRightClick = (event) => {
        event.preventDefault()
        overlayPanelRef.current.toggle(event)
    }

    const calculateRemainingQty = (buyerPOItem) => {
        let totalScheduledQty = 0
        datewisePOScheduleItems?.forEach(eachPOScheduleItem => {
            if (eachPOScheduleItem.buyerReqItemId === buyerPOItem.buyerReqItemId) {
                totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
            }
        })
        const totalAvailableQty = buyerPOItem?.bPOQty - totalScheduledQty

        return totalAvailableQty
    }

    const handleCustomScheduler = () => {
        let datewisePOSchedule = {
            columnId: uuid(),
            isNew: true,
        }
        let datewisePOScheduleItems = buyerPOItems?.map(eachBuyerPOItem => ({ ...eachBuyerPOItem, columnItemId: uuid(), columnId: datewisePOSchedule?.columnId, scheduledQty: 0, isNew: true }))
        setDatewisePOSchedule(prevState => ([...prevState, datewisePOSchedule]))
        setDatewisePOScheduleItems(prevState => ([...prevState, ...datewisePOScheduleItems]))
    }

    const handleCreateWithRemainingQty = () => {
        let datewisePOSchedule = {
            columnId: uuid(),
            isNew: true,
        }

        let datewisePOScheduleItems = buyerPOItems?.map(eachBuyerPOItem => {
            let remainingQty = calculateRemainingQty(eachBuyerPOItem)
            return {
                ...eachBuyerPOItem,
                columnItemId: uuid(),
                columnId: datewisePOSchedule?.columnId,
                scheduledQty: remainingQty,
                isNew: true
            }
        })

        setDatewisePOSchedule(prevState => ([...prevState, datewisePOSchedule]))
        setDatewisePOScheduleItems(prevState => ([...prevState, ...datewisePOScheduleItems]))
    }

    const handleRemoveClick = (columnId) => {
        const updatedPOSchedule = datewisePOSchedule?.filter(eachPOSchedule => eachPOSchedule?.columnId !== columnId)
        const updatedPOScheduleItems = datewisePOScheduleItems?.filter(eachPOScheduleItem => eachPOScheduleItem?.columnId !== columnId)
        setDatewisePOSchedule(updatedPOSchedule)
        setDatewisePOScheduleItems(updatedPOScheduleItems)
    }

    const handleDiscardClick = () => {
        if (window.confirm("Do you want to discard the changes?")) {
            setIsEditable(false)
            setDisablePunchButton(false)
            setDatewisePOSchedule(initialPOSchedule)
            setDatewisePOScheduleItems(initialPOScheduleItems)
        }
    }

    let activePOSchedule = poSchedule?.find(eachPOSchedule => eachPOSchedule?.statusId === 1)
    let canEditable = false
    if (activePOSchedule?.createdBy === usersData?.userId) {
        canEditable = true
    } else {
        canEditable = getBranchComparision(usersData?.activeUserRoleDetails?.branchId, buyerPO?.pmBranchId)
    }

    let permissions = []
    if (canEditable) {
        permissions = []
    }
    if (!buyerPO.isRecurringPO && poSchedule?.length >= 2) {
        permissions = [17]
    }

    const calculateMinDate = (eachPOSchedule, datewisePOSchedule, punchingIndex) => {
        let minDate
        if (!eachPOSchedule.isSchedulePunched) {
            if (punchingIndex > 0) {
                const previousScheduleDate = new Date(datewisePOSchedule[punchingIndex - 1]?.scheduledDate)
                minDate = new Date(previousScheduleDate)
                minDate.setDate(minDate.getDate() + 1)
            } else {
                minDate = new Date()
            }
        } else {
            minDate = new Date()
        }
        return minDate
    }

    const calculateMaxDate = (eachPOSchedule, datewisePOSchedule, punchingIndex) => {
        let leadtimeDate = new Date()
        leadtimeDate.setDate(leadtimeDate.getDate() + 999)
        let punchedMaxDate = new Date(datewisePOSchedule[punchingIndex]?.scheduledDate)
        punchedMaxDate.setDate(punchedMaxDate.getDate() - 1)
        return eachPOSchedule.isSchedulePunched ? punchedMaxDate : leadtimeDate
    }

    const isPreviousSchedulePunchedButNotDispatched = (currentIndex) => {
        if (currentIndex > 0) {
            const previousPOSchedule = datewisePOSchedule[currentIndex - 1]
            return previousPOSchedule?.isSchedulePunched && !previousPOSchedule?.isScheduleDispatched
        }
        return false
    }

    const renderPOScheduleColumn = (index, eachBuyerPOItem, eachPOSchedule, datewisePOScheduleItems) => {
        const relatedNewPOScheduleItem = datewisePOScheduleItems.find(
            item => item.buyerPOItemId === eachBuyerPOItem.buyerPOItemId && item.columnId === eachPOSchedule.columnId
        )

        let totalScheduledQty = 0
        datewisePOScheduleItems?.map(eachPOScheduleItem => {
            if (eachPOScheduleItem.buyerReqItemId === eachBuyerPOItem.buyerReqItemId) {
                totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
            }
        })

        const todayDate = new Date()
        todayDate.setDate(todayDate.getDate() - 1)
        const isScheduledDatePassed = Date.parse(eachPOSchedule?.scheduledDate) < todayDate

        let isForceClosed = false
        if(buyerPO.statusId !== 3){
            isForceClosed = true
        }
        
        if (eachBuyerPOItem.buyerPOId) {
            return (
                <div className={`flex flex-row align-items-center ${eachPOSchedule.isScheduleDispatched ? "dispatched-schedule" : eachPOSchedule.isSchedulePunched ? "punched-schedule" : ""}`} style={{ width: '70px' }}>
                    <TextInputField
                        name="scheduledQty"
                        value={relatedNewPOScheduleItem?.scheduledQty ? relatedNewPOScheduleItem?.scheduledQty : 0}
                        disabled={(!relatedNewPOScheduleItem?.isNew && !isEditable) || eachPOSchedule.isScheduleDispatched || eachPOSchedule.isSchedulePunched}
                        permissions={isScheduledDatePassed ? [16] : [15]}
                        onChange={e => handleInputChange(e, relatedNewPOScheduleItem?.columnItemId, relatedNewPOScheduleItem?.buyerPOItemId, (totalScheduledQty))}
                    />
                </div>
            )
        } else {
            return (
                <div style={{ width: '70px' }}>
                    {eachPOSchedule.isScheduleDispatched ? (
                        <>
                            <span style={{ fontSize: '10px' }}>Dispatched On:</span>
                            <br />
                            <span>{eachPOSchedule.dispatchedOn ? moment(eachPOSchedule.dispatchedOn).format("DD-MMM-YY") : "N/A"}</span>
                        </>
                    ) : eachPOSchedule.isSchedulePunched ? (
                        <>
                            <span style={{ fontSize: '10px' }}>Punched On:</span>
                            <br />
                            <span>{moment(eachPOSchedule.punchedOn).format("DD-MMM-YY")}</span>
                        </>
                    ) : (
                        index === punchingIndex && (
                            <Button 
                                className="py-0"
                                label={<p className="p-0 m-0"><span style={{fontSize: "11px", lineHeight: "0px"}}>ALLOCATE</span> <br /> <span>BATCH</span> </p>}
                                onClick={() => handlePunchClick(eachPOSchedule.columnId, eachPOSchedule?.scheduledDate)}
                                disabled={disablePunchButton || isForceClosed} // isPreviousSchedulePunchedButNotDispatched(index)
                                permissions={[194]}
                            />
                        )
                    )}
                </div>
            );

        }
    }

    const getProductDetail = (row) => {
        const relatedMaterialData = materialData?.find(eachMaterial => eachMaterial.materialId === row.materialId)
        const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === relatedMaterialData?.brandId)

        let productName = getProductName(relatedBrand?.brandName, relatedMaterialData?.productName, relatedMaterialData?.variantName)
        let productSpecification = getProductSpecification(relatedMaterialData?.productSpecification, relatedMaterialData?.UOM, relatedMaterialData?.UOMValue)

        return row.buyerPOId ? <div className="" style={{textWrap: "wrap", width: "400px"}}>{productName} | <span style={{fontSize: "13px"}}>{productSpecification}</span></div> : null
    }

    const getTotalScheduledQty = (row) => {
        let totalScheduledQty = 0
        datewisePOScheduleItems?.map(eachPOScheduleItem => {
            if (eachPOScheduleItem.buyerReqItemId === row.buyerReqItemId) {
                totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
            }
        })
        return row.buyerPOId ? <div style={{textAlign: "center"}}>{totalScheduledQty}</div> : null
    }

    const getQtyToSchedule = (row) => {
        let totalScheduledQty = 0
        datewisePOScheduleItems?.map(eachPOScheduleItem => {
            if (eachPOScheduleItem.buyerReqItemId === row.buyerReqItemId) {
                totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
            }
        })

        return row.buyerPOId ? <div className="py-1" style={{ textAlign:"center" }}>{row?.totalAvailableQty ? row?.totalAvailableQty : row?.bPOQty - totalScheduledQty}</div> : null
    }

    const getTotalPunchedQty = (row) => {
        let totalPunchedQty = 0

        if (punchingIndex === -1 && datewisePOSchedule.every(eachPOSchedule => eachPOSchedule.isNew)) {
            return row.buyerPOId ? <div className="">{totalPunchedQty}</div> : null
        }
        const sliceIndex = punchingIndex === -1 ? datewisePOSchedule.length : punchingIndex
        totalPunchedQty = datewisePOSchedule.slice(0, sliceIndex).reduce((total, eachPOSchedule) => {
            const relatedNewPOScheduleItem = datewisePOScheduleItems.find(eachPOScheduleItem =>
                eachPOScheduleItem.buyerPOItemId === row.buyerPOItemId && eachPOSchedule.columnId === eachPOScheduleItem.columnId
            )
            return total + (relatedNewPOScheduleItem ? parseFloat(relatedNewPOScheduleItem.scheduledQty) : 0)
        }, 0)
        return row.buyerPOId ? <div className="" style={{textAlign: "center"}}>{totalPunchedQty}</div> : null
    }

    const getQtyToPunch = (row) => {
        let totalScheduledQty = 0
        datewisePOScheduleItems?.map(eachPOScheduleItem => {
            if (eachPOScheduleItem.buyerReqItemId === row.buyerReqItemId) {
                totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
            }
        })

        let totalPunchedQty = 0
        let qtyToPunch = 0

        if (punchingIndex === -1 && datewisePOSchedule.every(eachPOSchedule => eachPOSchedule.isNew)) {
            totalPunchedQty = totalScheduledQty
            return row.buyerPOId ? <div className="">{totalPunchedQty}</div> : null
        }

        const sliceIndex = punchingIndex === -1 ? datewisePOSchedule.length : punchingIndex
        totalPunchedQty = datewisePOSchedule.slice(0, sliceIndex).reduce((total, eachPOSchedule) => {
            const relatedNewPOScheduleItem = datewisePOScheduleItems.find(eachPOScheduleItem =>
                eachPOScheduleItem.buyerPOItemId === row.buyerPOItemId && eachPOSchedule.columnId === eachPOScheduleItem.columnId
            )
            return total + (relatedNewPOScheduleItem ? parseFloat(relatedNewPOScheduleItem.scheduledQty) : 0)
        }, 0)

        qtyToPunch = totalScheduledQty - totalPunchedQty
        return row.buyerPOId ? <div className="" style={{textAlign: "center"}}>{qtyToPunch}</div> : null
    }

    return (
        <div className="scheduling-tab">
            <div className="flex flex-row justify-content-end">
                <div className="mb-2 mr-2">
                    {isEditable ? <Button className="small-btn ml-3 discard-btn" label="Discard" onClick={() => handleDiscardClick()} /> : ""}
                    {
                        !poSchedule[0]?.poScheduleId ?
                            <Button className="small-btn ml-3" label="Schedule" disabled={buyerPO?.statusId === 6} permissions={[12]} onClick={() => handleScheduledClick(buyerPO)} />
                            :
                            isEditable ?
                                <Button className="small-btn ml-3" label="Reschedule" permissions={[12]} onClick={() => handleReScheduleClick()} />
                                :
                                <Button className="small-btn ml-3" label="Edit" disabled={[4, 6].includes(buyerPO?.statusId) || !canEditable} permissions={permissions} onClick={() => handleEditClick()} /> //|| !canEditable
                    }
                </div>
            </div>

            <div className={`mb-5 ${buyerPO?.statusId === 6 ? 'cancelled-watermark' : ''} ${buyerPO?.statusId === 4 ? 'force-closed-watermark' : ''}`} style={{ overflowX: datewisePOSchedule.length > 2 ? 'auto' : 'hidden', whiteSpace: 'nowrap' }}>
                <div className="custom-table-container" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                    <table className="custom-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
                            <tr>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', backgroundColor: '#dce2ed', position: 'sticky', left: 0, zIndex: 2 }}>Material Id</th>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', width: '200px' }}>Product</th>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>PO Qty</th>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>Scheduled Qty</th>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>Qty To Schedule</th>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>Ttl Punched Qty</th>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>Qty To Punch</th>
                                <th style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>Buyer Del. Period</th>
                                
                                {datewisePOSchedule.map((eachPOSchedule, index) => (
                                    <th key={index} style={{ padding: '8px', border: '1px solid #dee2e6', width: '92px' }}>
                                        <div className={`flex flex-row align-items-center ${eachPOSchedule.isScheduleDispatched ? "dispatched-schedule" : eachPOSchedule.isSchedulePunched ? "punched-schedule" : ""} tooltip-scheduled-date-${eachPOSchedule.columnId}`}>
                                            <CalendarField
                                                value={eachPOSchedule?.scheduledDate === "2099-12-31" ? null : new Date(eachPOSchedule?.scheduledDate)}
                                                minDate={calculateMinDate(eachPOSchedule, datewisePOSchedule, punchingIndex)}
                                                maxDate={calculateMaxDate(eachPOSchedule, datewisePOSchedule, punchingIndex)}
                                                disabled={!eachPOSchedule?.isNew && !isEditable || (isEditable && eachPOSchedule.isScheduleDispatched)}
                                                dateFormat="dd-M"
                                                placeholder={eachPOSchedule?.scheduledDate === "2099-12-31" ? "Unknown" : ""}
                                                onChange={(e) => handleHeaderDateChange(e, eachPOSchedule?.columnId)}
                                            />
                                            <Button 
                                                className="mb-5 ml-0 p-1 pt-1" 
                                                icon="pi pi-times" 
                                                style={{ width: "35%" }} 
                                                severity="danger" 
                                                disabled={!eachPOSchedule?.isNew && !isEditable || (isEditable && (eachPOSchedule.isScheduleDispatched || eachPOSchedule.isSchedulePunched))} 
                                                text 
                                                onClick={() => handleRemoveClick(eachPOSchedule?.columnId)} 
                                            />
                                            <Tooltip target={`.tooltip-scheduled-date-${eachPOSchedule.columnId}`} position="top" autoHide>
                                                {eachPOSchedule.scheduledDate === "2099-12-31" ? "Unknown Date" : moment(eachPOSchedule.scheduledDate).format("DD-MMM-YYYY")}
                                            </Tooltip>
                                        </div>
                                    </th>
                                ))}
                                
                                {(isEditable || !poSchedule[0]?.poScheduleId) && (
                                    <th style={{ padding: '8px', border: '1px solid #dee2e6', width: '50px' }}>
                                        <Button icon="pi pi-plus-circle" onClick={() => handleAddClick()} onContextMenu={handleRightClick} />
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {updatedBuyerPOItems.map((row, rowIndex) => (
                                <tr key={rowIndex} style={{ backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#f8f9fa' }}>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6', position: 'sticky', left: 0, backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#f8f9fa', zIndex: 1 }}>{row.materialId}</td>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6' }}>{getProductDetail(row)}</td>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>{row.bPOQty}</td>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>{getTotalScheduledQty(row)}</td>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>{getQtyToSchedule(row)}</td>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>{getTotalPunchedQty(row)}</td>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>{getQtyToPunch(row)}</td>
                                    <td style={{ padding: '8px', border: '1px solid #dee2e6', textAlign: 'center' }}>{row.leadTime}</td>
                                    
                                    {datewisePOSchedule.map((eachPOSchedule, colIndex) => (
                                        <td key={colIndex} style={{ padding: '8px', border: '1px solid #dee2e6' }}>
                                            {renderPOScheduleColumn(colIndex, row, eachPOSchedule, datewisePOScheduleItems)}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div>
                {poSchedule?.length > 0 ? <b className="">SCHEDULED HISTORY</b> : null}
                {
                    poSchedule.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((eachPOSchedule, index) => {
                        const relatedPOScheduleItems = poScheduleItems.filter(eachPOScheduleItem => eachPOScheduleItem.poScheduleId === eachPOSchedule.poScheduleId)
                        let dateWiseSchedules = {}
                        //let relatedPOSchedule = poSchedule?.filter(eachPOSchedule => eachPOSchedule?.statusId === 1)
                        relatedPOScheduleItems?.map(eachPOScheduleItem => {
                            if (Object.keys(dateWiseSchedules).includes(eachPOScheduleItem?.scheduledDate)){
                                dateWiseSchedules[eachPOScheduleItem?.scheduledDate].push(eachPOScheduleItem) 
                            }else{
                                dateWiseSchedules[eachPOScheduleItem?.scheduledDate] = [eachPOScheduleItem]
                            }
                        })

                        let newPOSchedules = []
                        let newPOScheduleItems = []
                        Object.keys(dateWiseSchedules)?.map(eachSchedule => {
                            let newSchedule = {scheduledDate : eachSchedule, columnId : uuid(), isNew : false}
                            let newScheduleItems = dateWiseSchedules[eachSchedule]?.map(eachScheduleItem => {
                                const relatedBuyerPOItem = buyerPOItems?.find(eachBuyerPOItem => eachBuyerPOItem?.buyerPOItemId === eachScheduleItem?.buyerPOItemId)
                                return {...eachScheduleItem, columnId: newSchedule?.columnId, columnItemId: uuid(), isNew: false, ...relatedBuyerPOItem }
                            })
                            newPOSchedules.push(newSchedule)
                            newPOScheduleItems.push(...newScheduleItems)
                        })

                        newPOSchedules = sortArrayOfObjectsInAscendingDateOrder(newPOSchedules, "scheduledDate")
                        const createdUser = scheduleCreatedUsers?.find(eachUser => eachUser?.userId === eachPOSchedule?.createdBy)
                        const name = getFullName(createdUser?.firstName, createdUser?.lastName)
                        let relatedRescheduleReason = {}
                        if (poRescheduleReasons.length){
                            relatedRescheduleReason = poRescheduleReasons.find(each => each.poRescheduleReasonId === eachPOSchedule.poRescheduleReasonId)
                        }

                        return (
                            <div className="flex justify-content-between flex-column">
                                <div className="flex flex-row justify-content-center">
                                    <p className="mr-3 font-bold">
                                        Created By: <span style={{ fontWeight: 'normal', fontSize: '1em' }}>{name}</span> On: <span style={{ fontWeight: 'normal', fontSize: '1em' }}>{getDateString(eachPOSchedule?.createdAt)}</span>
                                        {relatedRescheduleReason?.poRescheduleReason && <>, Reason: <span style={{ fontWeight: 'normal', fontSize: '1em' }}>{relatedRescheduleReason.poRescheduleReason}</span></>}
                                        {eachPOSchedule?.docProof && <>, DocProof: <a href={eachPOSchedule.docProof} target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'normal', fontSize: '1em', marginLeft: '5px', color: 'blue', textDecoration: 'underline' }}>View</a></>}
                                    </p>
                                </div>
                                <div className="flex flex-wrap py-2 w-full">
                                    <div className="flex justify-content-between flex-grow-1 font-bold text-sm header-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                                        <div className="mb-1" style={{ fontSize: "13px", width: '8%' }}>Material Id</div>
                                        <div className="mb-1" style={{ fontSize: "13px", width: '26%' }}>Product</div>
                                        <div className="mb-1" style={{ fontSize: "13px", width: '8%' }}>PO Qty</div>
                                        <div className="mb-1" style={{ fontSize: "13px", width: '8%' }}>Scheduled Qty</div>
                                        {
                                            newPOSchedules?.map((eachPOSchedule) => {
                                                return (
                                                    <div className={`flex flex-row justify-content-between align-items-center mb-2 ml-1 tooltip-scheduled-date-${eachPOSchedule.columnId}`} style={{ width: "12%" }}>
                                                        <div style={{ fontSize: "13px", width: '100%' }}>
                                                            {eachPOSchedule.scheduledDate === "2099-12-31" ? "Unknown" : moment(eachPOSchedule.scheduledDate).format("DD-MMM")}
                                                        </div>
                                                        <Tooltip target={`.tooltip-scheduled-date-${eachPOSchedule.columnId}`} position="top" autoHide>
                                                            {eachPOSchedule.scheduledDate === "2099-12-31" ? "Unknown Date" : moment(eachPOSchedule.scheduledDate).format("DD-MMM-YYYY")}
                                                        </Tooltip>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        buyerPOItems.map(eachBuyerPOItem => {
                                            let totalScheduledQty = 0
                                            newPOScheduleItems?.map(eachPOScheduleItem => {
                                                if (eachPOScheduleItem.buyerReqItemId === eachBuyerPOItem.buyerReqItemId) {
                                                    totalScheduledQty += parseFloat(eachPOScheduleItem?.scheduledQty)
                                                }
                                            })
                                            const relatedMaterialData = materialData?.find(eachMaterial => eachMaterial.materialId === eachBuyerPOItem.materialId)
                                            const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === relatedMaterialData?.brandId)

                                            let productName = getProductName(relatedBrand?.brandName, relatedMaterialData?.productName, relatedMaterialData?.variantName) // relatedMaterialData?.companyProdName ? relatedMaterialData?.companyProdName : relatedMaterialData?.productName
                                            let productSpecification = getProductSpecification(relatedMaterialData?.productSpecification, relatedMaterialData?.UOM, relatedMaterialData?.UOMValue) // relatedMaterialData?.companyProdSpec ? relatedMaterialData?.companyProdSpec : relatedMaterialData?.productSpecification

                                            return (
                                                <div className="flex justify-content-between flex-grow-1 text-sm w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                                                    <div className="py-1 align-self-center" style={{ fontSize: "13px", width: '8%' }}>{eachBuyerPOItem?.materialId}</div>
                                                    <div className="py-1 align-self-center" style={{ fontSize: "13px", width: '26%' }}>{productName} | {productSpecification} | {getUOMStr(relatedMaterialData?.UOM, relatedMaterialData?.UOMValue)}   </div>
                                                    <div className="py-1 align-self-center" style={{ fontSize: "13px", width: '8%' }}>{eachBuyerPOItem?.bPOQty}</div>
                                                    <div className="py-1 align-self-center" style={{ fontSize: "13px", width: '8%' }}>{totalScheduledQty}</div>
                                                    {
                                                        newPOSchedules?.map(eachPOSchedule => {
                                                            const relatedNewPOScheduleItem = newPOScheduleItems?.find(eachPOScheduleItem => eachPOScheduleItem?.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId && eachPOSchedule?.columnId === eachPOScheduleItem?.columnId)
                                                            return (
                                                                <>
                                                                    <div className="py-1 align-self-center mb-2 mr-1" style={{ fontSize: "13px", width: '12%', textAlign: 'center' }}>
                                                                        {relatedNewPOScheduleItem?.scheduledQty ? relatedNewPOScheduleItem?.scheduledQty : 0}
                                                                    </div>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                                <br />                                {
                                    poSchedule.length > 1 ? <hr /> : null
                                }
                                <br />
                            </div>
                        )
                    })
                }
            </div>

            <Dialog header="SELECT RESCHEDULE REASON" visible={isSelectReasonModelVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => { setIsSelectReasonModelVisible(false) }}>
                <div className="vendor-payment-summary-tab" style={{ width: "100%", paddingLeft: "0%", paddingRight: "0%" }}>
                    <PoRescheduleReasonModel handleScheduledClick={handleScheduledClick} selectedScheduledDate={selectedScheduledDate} buyerPO={buyerPO} initialPOSchedule={initialPOSchedule} datewisePOSchedule={datewisePOSchedule} buyerPOItems={buyerPOItems} setIsLoading={setIsLoading} setIsSelectReasonModelVisible={setIsSelectReasonModelVisible} />
                </div>
            </Dialog>

            <Dialog header="RECCURING PO PUNCH" visible={isReccuringPoModalVisible} style={{ width: '40vw', minHeight: "20vh", }} onHide={() => setIsReccuringPoModalVisible(false)}>
                <RecurringPoModal datewisePOSchedule={datewisePOSchedule} poPunchItems={poPunchItems} punchingIndex={punchingIndex} datewisePOScheduleItems={datewisePOScheduleItems} selectedColumnId={selectedColumnId} buyerPO={buyerPO} poPunch={poPunch} poSchedule={poSchedule} buyerPOItems={buyerPOItems} initialPOSchedule={initialPOSchedule} initialPOScheduleItems={initialPOScheduleItems} getBuyerPO={getBuyerPO} setIsLoading={setIsLoading} setBuyerPO={setBuyerPO} setIsReccuringPoModalVisible={setIsReccuringPoModalVisible} setDatewisePOSchedule={setDatewisePOSchedule} setDatewisePOScheduleItems={setDatewisePOScheduleItems} dispatchNoteItems={dispatchNoteItems} />
            </Dialog>

            <Dialog header="SMART SCHEDULER" visible={isSmartSchedulerVisible} style={{ width: '400px', minHeight: "20vh", }} onHide={() => setIsSmartSchedulerVisible(false)}>
                <SmartScheduler handleCustomScheduler={handleCustomScheduler} setIsSmartSchedulerVisible={setIsSmartSchedulerVisible} datewisePOSchedule={datewisePOSchedule} poPunchItems={poPunchItems} punchingIndex={punchingIndex} datewisePOScheduleItems={datewisePOScheduleItems} selectedColumnId={selectedColumnId} buyerPO={buyerPO} poPunch={poPunch} poSchedule={poSchedule} buyerPOItems={buyerPOItems} initialPOSchedule={initialPOSchedule} initialPOScheduleItems={initialPOScheduleItems} getBuyerPO={getBuyerPO} setIsLoading={setIsLoading} setBuyerPO={setBuyerPO} setDatewisePOSchedule={setDatewisePOSchedule} setDatewisePOScheduleItems={setDatewisePOScheduleItems} dispatchNoteItems={dispatchNoteItems} />
            </Dialog>

            <OverlayPanel ref={overlayPanelRef}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Button label="Custom Schedule" onClick={() => { handleAddClick(); overlayPanelRef.current.hide() }} className="p-button-secondary" />
                    <Button label="Create with Remaining Qty" onClick={() => { handleCreateWithRemainingQty(); overlayPanelRef.current.hide() }} className="p-button-primary" />
                </div>
            </OverlayPanel>
            {
                (buyerPO?.isPunchDone && showSubmitPO) && (
                    <TabPanel header="PO Punch">
                        <SubmitPOQuantity
                            setIsLoading={setIsLoading}
                            materialData={materialData}
                            getBuyerPO={getBuyerPO}
                            setBuyerPO={setBuyerPO}
                            setBuyerPOItems={setBuyerPOItems}
                            buyerPO={buyerPO}
                            buyerPOItems={buyerPOItems}
                            poPunch={poPunch}
                            poPunchItems={poPunchItems}
                            poPunchCreatedUsers={poPunchCreatedUsers}
                            handleUpdatedPOPunch={handleUpdatedPOPunch}
                        />
                    </TabPanel>
                )
            }
        </div>
    )
}

export default Scheduling;